export const communities = [
  "ACH",
  "APL",
  "APR",
  "BBV",
  "CCI",
  "CCV",
  "DVF",
  "ELR",
  "ETH",
  "FRV",
  "GSV",
  "HSD",
  "LHN",
  "LPH",
  "MGC",
  "OCV",
  "RWV",
  "SBV",
  "SLN",
  "TCK",
  "TGB",
  "WCD",
  "WCF",
  "WRC",
];
